import React, {useContext, useEffect, useState} from "react";
import {
    IAlert,
    IDiscrepancyParams,
    IDiscrepancyTagParams,
    DiscrepancyAlertType
} from "@leap4/entities-discrepancy-common";
import {DiscrepancyMetrics, Sign} from "../../../enums";
import {enumNamesToSelect, FormChips, Grid, FormHelperText, TextField} from "@leap4/frontend";
import {AlertContext} from "../AlertContex";
import {urlService} from "../../../../../routing/urlsService";

const MetricSelect = enumNamesToSelect(DiscrepancyMetrics);
const SignSelect = enumNamesToSelect(Sign);
const TypeSelect = enumNamesToSelect(DiscrepancyAlertType);



export const DiscrepancyTagParamsForm = () => {
    const {alert, setAlert} = useContext(AlertContext);
    const alertParams = alert.params as IDiscrepancyParams;
    const discrepancyTagParams = alertParams?.params as IDiscrepancyTagParams;

    const updateAlertParams = (e) => {
        setAlert({...alert, params:{...alert.params, params:{...discrepancyTagParams, [e.target.name]: e.target.value}}} as IAlert)
    };

    return <>
        <Grid container direction={"row"} justifyContent={"flex-start"} alignItems={"flex-start"} gap={"10px"}>
            <Grid item xs={3.8} md={3.8}>
                <FormHelperText>
                    Minimum Selected Metric Value - Ad Server Side
                </FormHelperText>
                <TextField
                    fullWidth
                    value={discrepancyTagParams?.minMetricValueAdServerSide}
                    onChange={updateAlertParams}
                    size="small"
                    variant="outlined"
                    name="minMetricValueAdServerSide"
                    className={"gridItem"}
                />
            </Grid>

            <Grid item xs={3.8} md={3.8}>
                <FormHelperText>
                    Minimum Selected Metric Value - Publisher Side
                </FormHelperText>
                <TextField
                    fullWidth
                    value={discrepancyTagParams?.minMetricValuePublisherSide}
                    onChange={updateAlertParams}
                    size="small"
                    variant="outlined"
                    name="minMetricValuePublisherSide"
                    className={"gridItem"}
                />
            </Grid>
        </Grid>
    </>
}

export const DiscrepancyParamsForm = () => {
    const {alert, setAlert, dataPoints} = useContext(AlertContext);
    const alertParams = alert.params as IDiscrepancyParams;
    const [availableDataPoints, setAvailableDataPoints] = useState([]);

    useEffect(() => {
        const relevantDataPoint = dataPoints.filter(point => point.type === "publisher_login")
        setAvailableDataPoints(relevantDataPoint)
    }, [dataPoints]);

    const handleTypeChange = (e) =>{
        const newDiscrepancyType = e.target.value
        let discrepancyParams = {};
        if (newDiscrepancyType === DiscrepancyAlertType.PUBLISHER_TAG){
            discrepancyParams = {
                minMetricValueAdServerSide:0,
                minMetricValuePublisherSide:0
            }
        }
        setAlert({...alert,params: {...alertParams, type: newDiscrepancyType, params: discrepancyParams}})
    }

    const updateAlertParams = (e) => {
        setAlert({...alert, params: {...alert.params, [e.target.name]: e.target.value}} as IAlert)
    };

    const updateRelevantPlatforms = (relevantPlatforms: string[]) => {
        setAlert({...alert, params: {...alert.params, relevantPlatforms: relevantPlatforms}})
    }

    const getLinkToEditDatePoint = (dataPointId) => {
        return urlService.editDataPoint(dataPointId)
    }

    return <>
        <Grid container direction={"row"} justifyContent={"flex-start"} alignItems={"flex-start"} gap={"10px"}>
            <Grid item xs={3.8} md={3.8}>
                <FormHelperText>
                    Metric
                </FormHelperText>
                <MetricSelect
                    required
                    fullWidth
                    value={alertParams?.metric}
                    onChange={updateAlertParams}
                    name="metric"
                    style={{height:"43px"}}
                />
            </Grid>

            <Grid item xs={3.8} md={3.8}>
                <FormHelperText>
                    Sign
                </FormHelperText>
                <SignSelect
                    required
                    fullWidth
                    value={alertParams?.sign}
                    onChange={updateAlertParams}
                    name="sign"
                    defaultValue={Sign.POSITIVE}
                    style={{height:"43px"}}
                />
            </Grid>

            <Grid item xs={3.8} md={3.8}>
                <FormHelperText>
                    Percent
                </FormHelperText>
                <TextField
                    fullWidth
                    value={alertParams?.percent}
                    onChange={updateAlertParams}
                    size="small"
                    variant="outlined"
                    name="percent"
                    className={"gridItem"}
                />
            </Grid>
        </Grid>

        <Grid container direction={"row"} justifyContent={"flex-start"} alignItems={"flex-start"} gap={"10px"}>
            <Grid item xs={3.8} md={3.8}>
                <FormHelperText>
                    From Days Ago
                </FormHelperText>
                <TextField
                    fullWidth
                    value={alertParams?.fromDaysAgo}
                    onChange={updateAlertParams}
                    size="small"
                    variant="outlined"
                    name="fromDaysAgo"
                    className={"gridItem"}
                />
            </Grid>

            <Grid item xs={3.8} md={3.8}>
                <FormHelperText>
                    To Days Ago
                </FormHelperText>
                <TextField
                    fullWidth
                    value={alertParams?.toDaysAgo}
                    onChange={updateAlertParams}
                    size="small"
                    variant="outlined"
                    name="toDaysAgo"
                    className={"gridItem"}
                />
            </Grid>
            <Grid item>
                <FormChips optionsList={availableDataPoints} valueKey={"_id"} labelKey={"name"}
                           onUpdateItems={updateRelevantPlatforms}
                           inputName={"Relevant Platforms"} enableCreate={false}
                           chips={[...(alert.params as any).relevantPlatforms]} link={getLinkToEditDatePoint} pureCreate={false}/>
            </Grid>
        </Grid>

        <Grid container direction={"row"} justifyContent={"flex-start"} alignItems={"flex-start"} gap={"10px"}>
            <Grid item xs={3.8} md={3.8}>
                <FormHelperText>
                    Discrepancy Type
                </FormHelperText>
                <TypeSelect
                    required
                    fullWidth
                    value={alertParams?.type}
                    onChange={handleTypeChange}
                    name="type"
                    defaultValue={DiscrepancyAlertType.PUBLISHER_TAG}
                    style={{height:"43px"}}
                />
            </Grid>
        </Grid>
        {alertParams?.type === DiscrepancyAlertType.PUBLISHER_TAG && <DiscrepancyTagParamsForm/>}
    </>
}


